import { configureStore } from '@reduxjs/toolkit';

import themeReducer from './slice/themeSlice';
import userReducer from './slice/userSlice';
import balanceReducer from './slice/balanceSlice';
import uiReducer from './slice/UISlice';
import builderQrReducer from './slice/builderQrSlice';
import ordersReducer from './slice/orderSlice';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        user: userReducer,
        balance: balanceReducer,
        ui: uiReducer,
        builder: builderQrReducer,
        orders: ordersReducer
    }
}); 